var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  version: 1.1,
  id: "Capa_1",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 512 512",
  style: {
    "enableBackground": "new 0 0 512 512"
  },
  xmlSpace: "preserve",
  fill: "#FEA832"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  fill: "#FEA832",
  d: "M311.5,474.6c-5.7,2.3-12.1,1.1-16.3-3.2L40.6,216.9c-4.2-4.2-5.5-10.6-3.2-16.3c2.3-5.7,7.6-9.3,13.8-9.1 c23.1-0.2,45.6-9.5,61.7-25.7l1.9-1.9h42.4l190.9,190.9v42.4l-1.9,1.9c-16.3,16.3-25.7,38.4-25.7,61.7 C320.8,467,317.2,472.3,311.5,474.6z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  fill: "#FEA832",
  d: "M498.8,13.2c-17.6-17.6-46-17.6-63.6,0c-17.6,17.6-17.6,46,0,63.6c17.6,17.6,46,17.6,63.6,0 C516.4,59.2,516.4,30.8,498.8,13.2z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  fill: "#FEA832",
  d: "M210.3,407.8c-29.3,29.3-76.8,29.3-106.1,0s-29.3-76.8,0-106.1c5.9-5.9,15.3-5.9,21.2,0l84.9,84.9 C216.2,392.5,216.2,401.9,210.3,407.8z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  fill: "#FEDB41",
  d: "M456.4,289L348.2,397.2L114.8,163.8L223,55.6c64.3-64.3,169.1-64.3,233.3,0S520.6,224.7,456.4,289z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  fill: "#FEDB41",
  d: "M326.9,503.2c-11.7,11.7-30.8,11.7-42.4,0L8.8,227.5c-11.7-11.7-11.7-30.8,0-42.4s30.8-11.7,42.4,0l275.8,275.8 C338.6,472.5,338.6,491.6,326.9,503.2z"
})));
export default __webpack_public_path__ + "static/media/bell_colored.c9a8f8f7.svg";
export { SvgComponent as ReactComponent };